import Axios from '@/utils/request'
export const baseUrl = Axios.defaults.baseURL

// export const showUrl = process.env.VUE_APP_IMG_URL
export const uploadUrl = baseUrl + '/file/file/upload' // 图片上传地址
export const markdownUpload = '/file/file/upload' // 图片上传地址
export const imgCodeUrl = baseUrl + '/open/portalConsult/getVCode' // 验证码图片地址
export const getAuthCode = baseUrl + '/user/oauth2/authorize' // 验证是否登录

export const showUrl = process.env.VUE_APP_IMG_URL
export const platformUrl = process.env.VUE_APP_PLATFORM_URL
export const loginUrl = platformUrl + '/login'

// 获取系统的回调地址
export const applicationAuth = (data) => {
    return Axios.request({
		method: "post",
		url: '/user/openUser/applicationAuth',
		data: data
    })
}
// 根据code获取token
export const authCodeLogin = (data) => {
    return Axios.request({
		method: "post",
		url: '/user/openUser/authCodeLogin',
		data: data
    })
}
// 获取用户信息
export const getUserinfo = (data) => {
	return Axios.request({
		method: "get",
		url: '/user/oauth2/userinfo',
		params: data
	})
}

// 获取字典数据
export const getByTypeCode = (data) => {
    return Axios.request({
        method: "get",
        url: '/user/dic/getByTypeCode',
        params: data
    })
}

// 获取首页banner轮播图
export const getBannerByPosition = (data) => {
    return Axios.request({
        method: "get",
        url: '/open/portalBanner/getByPosition',
        params: data
    })
}


// ---登录---
export const loginOpenUser = (data) => {
    return Axios.request({
        method: "post",
        url: '/idaas/open/loginOpenUser',
        data: data
    })
}
// 退出登录
export const loginOut = (data) => {
    return Axios.request({
        method: "get",
        url: '/user/login/logout',
        params: data
    })
}
// 获取当前登录用户的权限信息
export const getLoginUserOnline = (data) => {
    return Axios.request({
        method: "get",
        url: '/user/mandate/getLoginUserOnline',
        params: data
    })
}
// --- 注册 ---
// 注册
export const registerOpenUser = (data) => {
    return Axios.request({
        method: "post",
        url: '/idaas/open/registerOpenUser',
        data: data
    })
}
// 获取设置信息
export const getSysWebsite = (data) => {
    return Axios.request({
        method: "get",
        url: '/user/sysWebsite/getSysWebsite',
        params: data
    })
}
// --- 账户管理 ---
// 获取用户信息
export const getUserInfo = (data) => {
    return Axios.request({
        method: "get",
        url: '/user/openUser/getUserInfo',
        params: data
    })
}
// 消息中心
export const getMessageList = (data) => {
    return Axios.request({
        method: "get",
        url: '/user/openUser/getMessageList',
        params: data
    })
}
// 消息-标记已读
export const changeRead = (data) => {
    return Axios.request({
        method: "post",
        url: '/user/openUser/changeRead',
        data: data
    })
}
// 消息-删除
export const delMessageRemindUser = (data) => {
    return Axios.request({
        method: "post",
        url: '/user/openUser/delMessageRemindUser',
        data: data
    })
}
// 修改账户信息
export const updateUserInfo = (data) => {
    return Axios.request({
        method: "post",
        url: '/user/openUser/updateUserInfo',
        data: data
    })
}

// 认证企业
export const addEnterprise = (data) => {
    return Axios.request({
        method: "post",
        url: '/user/openEnterprise/add',
        data: data
    })
}
// 发送短信验证码
export const sendPhoneCode = (data) => {
    return Axios.request({
        method: "post",
        url: '/user/openUser/sendPhoneCode',
        data: data
    })
}
// 发送邮箱验证码
export const sendEmailCode = (data) => {
    return Axios.request({
        method: "post",
        url: '/user/openUser/sendEmailCode',
        data: data
    })
}
// 获取企业列表
export const getEnterpriseList = (data) => {
    return Axios.request({
        method: "get",
        url: '/user/openEnterprise/getByName',
        params: data
    })
}
// 申请加入企业
export const applyEnter = (data) => {
    return Axios.request({
        method: "post",
        url: '/user/openEnterprise/applyEnter',
        data: data
    })
}
// 获取申请加入信息
export const getApplyEnterpriseInfo = (data) => {
    return Axios.request({
        method: "get",
        url: '/user/openUser/getApplyEnterpriseInfo',
        params: data
    })
}
// 获取认证企业信息
export const getEnterpriseInfo = (data) => {
    return Axios.request({
        method: "get",
        url: '/user/openUser/getEnterpriseInfo',
        params: data
    })
}
// --- 关于平台 ----
// 获取平台资讯
export const getPortalMessageInfoList = (data) => {
    return Axios.request({
        method: "get",
        url: '/open/portalMessageInfo/getPortalMessageInfoList',
        params: data
    })
}
// 获取资讯详情
export const getPortalMessageInfo = (data) => {
    return Axios.request({
        method: "get",
        url: '/open/portalMessageInfo/getPortalMessageInfo',
        params: data
    })
}
// 获取资讯列表
export const getMessageInfoList = (data) => {
    return Axios.request({
        method: "get",
        url: '/open/portalMessageInfo/getFrontMessageInfoList',
        params: data
    })
}
// 获取版本记录
export const getVersionList = (data) => {
    return Axios.request({
        method: "get",
        url: '/open/portalPlatformVersion/getPortalPlatformVersionList',
        params: data
    })
}
// --- 咨询管理 ---
// 提交咨询
export const savePortalConsult = (data) => {
    return Axios.request({
        method: "post",
        url: '/open/portalConsult/savePortalConsult',
        data: data
    })
}
// 获取验证码
export const getLoginCode = (data) => {
    return Axios.request({
        method: "get",
        url: '/open/portalConsult/getLoginCode',
        params: data
    })
}
// --- 行业应用 ---
// 获取行业应用
export const getClassifyList = (data) => {
    return Axios.request({
        method: "get",
        url: '/open/portalIndustryClassify/getFrontIndustryClassifyList',
        params: data
    })
}
// ---获取版权信息 ---
export const getOptionInfo = (data) => {
    return Axios.request({
        method: "get",
        url: '/user/option/getOptionInfo',
        params: data
    })
}
// ---边缘层 ---
// 获取设备列表
export const getPortalDeviceList = (data) => {
    return Axios.request({
        method: "get",
        url: '/open/portalDevice/getPortalDeviceList',
        params: data
    })
}
// 获取产线方案列表
export const getPortalProductList = (data) => {
    return Axios.request({
        method: "get",
        url: '/open/portalProduct/getPortalProductList',
        params: data
    })
}
// 获取设备详情
export const getPortalDeviceById = (data) => {
    return Axios.request({
        method: "get",
        url: '/open/portalDevice/getPortalDevice',
        params: data
    })
}
// 获取产线详情
export const getPortalProduct = (data) => {
    return Axios.request({
        method: "get",
        url: '/open/portalProduct/getPortalProduct',
        params: data
    })
}
// ---- 首页-开发者中心热门讨论 ---
export const getHotDiscussList = (data) => {
    return Axios.request({
        method: "get",
        url: '/community/articleInfo/getHotDiscussList',
        params: data
    })
}
// 首页 -获取行业应用
export const getPortalList = (data) => {
    return Axios.request({
        method: "get",
        url: '/open/portalHome/getList',
        params: data
    })
}

// 获取用户企业信息
export const getUserEnterprise = (data) => {
    return Axios.request({
        method: "get",
        url: '/user/openUser/getUserEnterprise',
        params: data
    })
}
// 切换企业
export const switchUserEnterprise = (data) => {
    return Axios.request({
        method: "post",
        url: '/user/openUser/switchUserEnterprise',
        data: data
    })
}

// 记录页面访问次数
export const savePortalVisitStatistic = (data) => {
    return Axios.request({
        method: "post",
        url: '/open/portalIndex/savePortalVisitStatistic',
        data: data
    })
}
// ---供需对接 ---
// 获取供需列表
export const getSupplyDemandList = (data) => {
    return Axios.request({
        method: "get",
        url: '/open/supplyDemand/getList',
        params: data
    })
}
// 发布供需信息
export const saveSupplyDemand = (data) => {
    return Axios.request({
        method: "post",
        url: '/open/supplyDemand/saveSupplyDemand',
        data: data
    })
}
// 查看联系方式
export const getContactPhone = (data) => {
    return Axios.request({
        method: "get",
        url: '/open/supplyDemand/getContactPhone',
        params: data
    })
}
// ---应用市场 ---
// 置顶推荐
export const getIndexList = (data) => {
    return Axios.request({
        method: "get",
        url: "/open/topApp/getIndexList",
        params: data
    })
}
// --- 应用中心 ---
// 获取列表
export const getappCenterList = (data) => {
	return Axios.request({
		method: "get",
		url: '/open/appCenter/list',
		params: data
	})
}
// *** 解决方案 ***
// 获取列表
export const getsolutionList = (data) => {
	return Axios.request({
		method: "get",
		url: '/open/solution/list',
		params: data
	})
}
// 方案详情
export const getsolutionDetail = (data) => {
	return Axios.request({
		method: "get",
		url: '/open/solution/detail',
		params: data
	})
}
// 方案咨询
export const savesolution = (data) => {
    return Axios.request({
        method: "post",
        url: '/open/solutionConsult/save',
        data: data
    })
}
// *** 工业品发布 ***
// 获取工业品类型列表
export const getindustrialTypeList = (data) => {
	return Axios.request({
		method: "get",
		url: '/open/industrialType/list',
		params: data
	})
}
// 获取工业品列表
export const getIndustrialInfoList = (data) => {
	return Axios.request({
		method: "get",
		url: '/open/industrialInfo/list',
		params: data
	})
}
// 信息详情
export const getIndustrialInfoDetail = (data) => {
	return Axios.request({
		method: "get",
		url: '/open/industrialInfo/detail',
		params: data
	})
}
// 工业品咨询
export const saveIndustrialInfo = (data) => {
    return Axios.request({
        method: "post",
        url: '/open/industrialConsult/save',
        data: data
    })
}
// *** 开发者社区 ***
// 平台热门帖子
export const getTop4Article = (data) => {
	return Axios.request({
		method: "get",
		url: '/community/articleInfo/getTop4Article',
		params: data
	})
}
// *** 首页 ***
// --- 机理模型 ---
// 获取列表
export const getModelInfoList = (data) => {
    return Axios.request({
		method: "get",
		url: '/micro/mechanismModelInfo/getMechanismModelList',
		params: data
    })
}
// --- 微服务 ---
export const getServiceList = (data) => {
    return Axios.request({
		method: "get",
		url: '/micro/iotOpenService/getOpenList',
		params: data
    })
}
// --- 平台成就 ---
export const getPlatformAchievement = (data) => {
    return Axios.request({
		method: "get",
		url: '/user/homePage/platformAchievement',
		params: data
    })
}
// --- 平台案例 ---
export const getCaseList = (data) => {
    return Axios.request({
		method: "get",
		url: '/open/case/list',
		params: data
    })
}
// // banner列表
// export const getList = (data) => {
//     return Axios.request({
// 		method: "get",
// 		url: '/open/portalBanner/getList',
// 		params: data
//     })
// }
// 获取版本号
export const getAppVersion = (data) => {
	return Axios.request({
		method: "get",
		url: '/open/portalPlatformVersion/getAppVersion',
		params: data
	})
}
// ---- 热搜文档 ---
export const getDocumentInfoList = (data) => {
    return Axios.request({
        method: "get",
        url: '/open/documentInfo/getList',
        params: data
    })
} 